import { CheckListData } from './CheckList';

export const checkLists: Record<string, CheckListData> = {
    testerText: {
        title: 'Naar een toegankelijke tekst',
        steps: [
            {
                id: 'afkortingenMetUitleg',
                text: 'Afkortingen alleen met duidelijke uitleg',
                internalLink: '/redacteur/taal',
            },
            {
                id: 'geenFiguurlijkeTaal',
                text: 'Geen spreekwoorden, figuurlijke taal, jargon of vaktaal (of uitleg)',
                internalLink: '/redacteur/taal',
            },
            {
                id: 'leesniveauB1A2',
                text: 'Leesniveau B1 en waar mogelijk A2',
                searchTerm: 'leesniveau',
            },
            {
                id: 'geenHoofdletters',
                text: 'Zo min mogelijk HOOFDLETTERS (normale woordvormen)',
                internalLink: '/redacteur/taal',
            },
            {
                id: 'geenEmojiInTekst',
                text: 'Geen emoji in plaats van tekst en geen reeksen emoji in tekst',
                internalLink: '/redacteur/sociale-media',
            },
            {
                id: 'geenUnicodeTeksteffecten',
                text: 'Geen unicode teksteffecten die lijken op letters, maar dat niet zijn',
                internalLink: '/redacteur/sociale-media',
            },
            {
                id: 'linksBeschrijvenDoel',
                text: "Links beschrijven het doel (niet 'klik hier' of 'lees meer')",
                searchTerm: '2.4.4',
            },
            {
                id: 'simpeleZinnenStructuur',
                text: 'Simpele zinnen en visuele structuur is aangebracht waar mogelijk (zoals met lijsten)',
                description:
                    'Gebruik de beschikbare functionaliteit die het platform biedt om de tekst duidelijk te structureren.',
            },
            {
                id: 'logischeKoppenstructuur',
                text: 'Koppenstructuur is logisch, consistent en volgens platform-functionaliteit',
                description:
                    'Bijvoorbeeld: Maak echt gebruik van de kop-functies in Word en maak tekst niet handmatig groter of bold om een kop te maken.',
                searchTerm: 'koppenstructuur',
                internalLink: '/ontwikkelaar/tools/extensies',
            },
            {
                id: 'kleuronafhankelijkeOpmaak',
                text: 'Betekenis van opmaak van tekst is kleuronafhankelijk',
                description:
                    'Bijvoorbeeld: een link is niet alleen gekleurd, maar heeft ook een onderlijn.',
                searchTerm: 'kleuronafhankelijk',
            },
            {
                id: 'voldoendeContrast',
                text: 'Het contrast op de voorgrond en achtergrond is voldoende',
                searchTerm: 'contrast',
            },
            {
                id: 'graphicsBijVeelTekst',
                text: 'Een grote hoeveelheid aan tekst wordt met graphics ondersteund',
            },
        ],
    },
    testerAfbeelding: {
        title: 'Naar een toegankelijke afbeelding',
        steps: [
            {
                id: 'tekstalternatiefAanwezig',
                text: 'Kloppend tekstalternatief is aanwezig',
                internalLink: '/alt-tekst',
            },
            {
                id: 'contrastInAfbeelding',
                text: 'Het contrast van informatie in de afbeelding is voldoende',
                searchTerm: 'contrast',
                internalLink: '/contrast',
            },
            {
                id: 'kleuronafhankelijkeInformatie',
                text: 'Informatie binnen de afbeelding is kleuronafhankelijk',
                searchTerm: 'kleuronafhankelijk',
            },
        ],
    },
    testerAnimatie: {
        title: 'Animatie controleren op toegankelijkheid',
        steps: [
            {
                id: 'geenFlikkering',
                text: 'Flikkering is minder dan 3 keer per seconde',
                internalLink: '/richtlijnen?q=2.3.1',
            },
            {
                id: 'alternatiefVoorAnimatie',
                text: 'Gelijkwaardig alternatief in tekst of audio is aanwezig',
            },
            {
                id: 'voldoendeContrastAnimatie',
                text: 'Contrasten binnen de animatie zijn voldoende',
                searchTerm: 'contrast',
            },
            {
                id: 'pauzerenStoppenOverslaan',
                text: 'Je kan pauzeren, stoppen of overslaan',
                internalLink: '/richtlijnen?q=2.2.2',
            },
            {
                id: 'animatieNietAfhankelijkVanKleur',
                text: 'De animatie is niet afhankelijk van kleur',
                searchTerm: 'kleuronafhankelijk',
            },
        ],
    },
    testerAudio: {
        title: 'Naar inclusieve audio',
        steps: [
            {
                id: 'geluidsbeschrijvingAanwezig',
                text: 'Geluidsbeschrijving is aanwezig',
                description:
                    'Transcriptie met geluidsomschrijving of ondertiteling voor doven en slechthorenden (minimaal één vereist)',
                internalLink: '/redacteur/audio-video/geluidsbeschrijving',
            },
        ],
    },
    testerOndertiteling: {
        title: 'Naar een goede ondertiteling',
        steps: [
            {
                id: 'alternatiefVoorGeluiden',
                text: 'Is een alternatief voor alle geluiden',
            },
            {
                id: 'visueelSaai',
                text: 'Ziet er visueel saai uit',
            },
            {
                id: 'duidelijkWieWatZegt',
                text: 'Maakt duidelijk wie wat zegt, waar welk geluid vandaan komt',
            },
            {
                id: 'voldoetAanNpoRichtlijnen',
                text: 'Voldoet aan de NPO Richtlijnen voor ondertiteling',
                internalLink: '/redacteur/audio-video/ondertiteling',
            },
        ],
    },
    testerVideo: {
        title: 'Naar een video voor iedereen',
        steps: [
            {
                id: 'audiodescriptieAanwezig',
                text: 'Audiodescriptie is aanwezig',
                searchTerm: 'audiodescriptie',
            },
            {
                id: 'ondertitelingAanwezig',
                text: 'Ondertiteling voor doven en slechthorenden is aanwezig',
                searchTerm: 'ondertiteling',
            },
            {
                id: 'kleuronafhankelijkeInformatieVideo',
                text: 'Informatie binnen de video is kleuronafhankelijk',
                searchTerm: 'kleuronafhankelijk',
            },
            {
                id: 'geenFlikkeringVideo',
                text: 'Flikkering is minder dan 3 keer per seconde',
                internalLink: '/richtlijnen?q=2.3.1',
            },
            {
                id: 'pauzerenStoppenOverslaanVideo',
                text: 'De video kan je pauzeren, stoppen of overslaan',
                internalLink: '/richtlijnen?q=2.2.2',
            },
        ],
    },
    testerEnquete: {
        title: 'Voor een inclusieve enquête',
        steps: [
            {
                id: 'inclusieveSoftware',
                text: 'Enquête software is inclusief (WCAG niveau AA)',
            },
            {
                id: 'duidelijkeLabels',
                text: 'Invulvakjes hebben duidelijke labels',
                internalLink: '/richtlijnen?q=labels',
            },
            {
                id: 'voorbeeldenBijEisen',
                text: 'Invulvakjes met bepaalde eisen hebben voorbeelden',
                searchTerm: '3.3.2',
            },
            {
                id: 'toegankelijkeMedia',
                text: 'Media in de enquête is toegankelijk volgens de richtlijnen',
            },
        ],
    },
    redacteurQuickStart: {
        title: 'Voordat je begint',
        steps: [
            {
                id: 'kennisValidisme',
                text: 'Ik weet wat validisme is',
                internalLink: '/wie/validisme',
            },
            {
                id: 'gezamenlijkeTaak',
                text: 'Ik weet wat onze gezamenlijke taak is',
                internalLink: '/taak',
            },
            {
                id: 'waarRichtlijnen',
                text: 'Ik weet waar mijn richtlijnen staan',
                internalLink: '/redacteur/richtlijnen',
            },
        ],
    },
    projectleiderTeamKwaliteit: {
        title: 'Naar een goed team',
        steps: [
            {
                id: 'diversTeam',
                text: 'Een divers team',
                internalLink: '/personas',
            },
            {
                id: 'kennisVanRichtlijnen',
                text: 'Een team waarvan iedereen op voorhand kennis heeft van de theorie en richtlijnen',
            },
            {
                id: 'productieVoldoetRichtlijnen',
                text: 'Een productie creëren die aan de richtlijnen voldoet',
                internalLink: '/richtlijnen',
            },
            {
                id: 'mensenMetBeperkingBetrekken',
                text: 'Het betrekken van mensen met een beperking in het proces',
                internalLink: '/wie/functievariatie',
            },
        ],
    },
};
